import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

// Define value map once
const valueMap: Record<string, string> = {
  C: 'Critical',
  H: 'High',
  M: 'Medium',
  L: 'Low',
};

// Create inverse automatically
const valueMapInverse = invertMap(valueMap);

const operatorMap: Record<string, string> = {
  'ENDS WITH': 'is',
};

const operatorMapInverse = invertMap(operatorMap);

/**
 * Meta filter: Severity is UI abstraction over status field's last character
 * "Severity is Critical" → "status ENDS WITH C"
 */
export const RiskSeverity: SimpleFilterDefinition = {
  apiField: 'status',
  uiField: 'Severity',
  inputType: 'dropdown',
  getAvailableValues: () =>
    Promise.resolve(['Critical', 'High', 'Medium', 'Low']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Severity',
      operator: getOperatorFromQueryFilter(queryFilter, operatorMap),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return (
      queryFilter.field === 'status' && queryFilter.operator === 'ENDS WITH'
    );
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'status',
      operator: getOperatorFromSimpleFilter(simpleFilter, operatorMapInverse),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
